import { Vue, Component, Prop, Provide } from 'vue-property-decorator';
import CommonUploadFile from '@/components/cards/common-upload-file/common-upload-file';
import SSOGoogle from './sso-types/sso-google/sso-google';
import SSOCredentials from './sso-types/sso-credentials/sso-credentials';
import SSOClasslink from './sso-types/sso-classlink/sso-classlink';
import SSOClever from './sso-types/sso-clever/sso-clever';
import SSOSaml from './sso-types/sso-saml/sso-saml';
import SSOLti from './sso-types/sso-lti/sso-lti';
import SSOwsfed from './sso-types/sso-wsfed/sso-wsfed';
import { isEmptyValue } from '@/utils/utils';

@Component({
    name: 'sso-type-setup',
    components: {
        'sso-google': SSOGoogle,
        'sso-credentials': SSOCredentials,
        'sso-classlink': SSOClasslink,
        'sso-clever': SSOClever,
        'sso-saml': SSOSaml,
        'sso-lti': SSOLti,
        'sso-wsfed': SSOwsfed,
        'sso-apple': SSOLti,
    },
})

export default class SsoTypeSetup extends Vue {

    @Provide('validator') public $validator: any = this.$validator;

    public isUploading: boolean = false;

    public userData: any;

    public selectedKey: any = 'google';

    public activeComponentSSO: any = '';

    @Prop({default: {}})
    public tenantData: any;

    @Prop({default: {}})
    public ssoDetails: any;

    @Prop({default: true})
    public isGroupHierarchySet: any;

    private selectedLoginTypes: any = [];

    private errorSelectSSO: boolean = false;

    private submitted: boolean = false;

    private nextError: boolean = false;

    private errorFoundAt: string = '';

    private errorCheckFor: any = {};

    private providerList: any = [
        {
            text: 'Google',
            value: 'google',
            checked: true,
        },
        {
            text: 'Credentials',
            value: 'credential',
            checked: false,
        },
        {
            text: 'Classlink',
            value: 'classlink',
            checked: false,
        },
        {
            text: 'Clever',
            value: 'clever',
            checked: false,
        },
        // {
        //     text: 'SAML',
        //     value: 'saml',
        // },
        {
            text: 'LTI',
            value: 'lti',
            checked: false,
        },
        // {
        //     text: 'WSFED',
        //     value: 'WSFED',
        // },
        // {
        //     text: 'Apple',
        //     value: 'apple',
        // },
    ];

    private ssoComponents: any = {
        google: 'sso-google',
        credential: 'sso-credentials',
        classlink: 'sso-classlink',
        clever: 'sso-clever',
        saml: 'sso-saml',
        lti: 'sso-lti',
        WSFED: 'sso-wsfed',
        apple: 'sso-apple',
    };

    private created() {
        this.onChangeSSOType();
    }

    private onSwitchComponent(key: any) {
        this.$emit('onSwitchComponent', 'tenant-list');
    }

    private onBackTolist(key: any) {
        this.$emit('onSwitchComponent', key);
    }

    private onChangeSSOType(value?: any) {
        if (value) {
            this.selectedKey = value;
            this.activeComponentSSO = this.ssoComponents[value];
        } else {
            this.activeComponentSSO = this.ssoComponents[this.selectedKey];
        }
        this.allowValidation();
    }

    private onNext(key: any) {
        this.selectedLoginTypes = [];
        this.errorSelectSSO = false;
        this.nextError = false;
        this.providerList.filter((item: any) => {
            if (item.checked) {
                this.selectedLoginTypes.push(item.value);
            }
        });
        if (this.selectedLoginTypes.includes('credential')) {
            if (!this.validatedPwPass(this.ssoDetails.credential.default_password)) {
                return;
            }
        }
        if (this.selectedLoginTypes && this.selectedLoginTypes.length > 0) {
            this.ssoDetails.login_type = this.selectedLoginTypes;
            this.submitted = true;
            this.$validator.validateAll().then((valid: any) => {
                if (valid) {
                    if (this.isGroupHierarchySet) {
                        this.$emit('onSwitchComponent', 'roster-setup');
                    } else {
                        this.$emit('onSwitchComponent', key);
                    }
                }
            });
        } else {
            this.errorSelectSSO = true;
        }
    }

    private allowValidation() {
        this.providerList.filter((item: any) => {
            this.errorCheckFor[item.value] = item.checked;
        });
    }

    private validatedPwPass(textPW: any) {
        const uppercase = /[A-Z]/g;
        const lowercase = /[a-z]/g;
        const numberReg = /[0-9]/g;
        const specialAllow = /[ !@#$%^&*()_+=]/g;
        const regexSplNotAllow = /[ \s\-\[\]{};':"\\|,.<>\/?]/g;
        if (textPW.length < 8 || textPW.length > 15 || !uppercase.test(textPW) ||
        !lowercase.test(textPW) || !numberReg.test(textPW) || regexSplNotAllow.test(textPW) ||
        !specialAllow.test(textPW)) {
            return false;
        } else {
            return true;
        }
    }

}
